import { IApplicationState } from '../../types/redux';

export function selectPageSection(state: IApplicationState) {
  return state.page.section;
}
